import { numberField, objectField, stringField } from "./parseFields";
import type { ComplianceVerifyJob } from "./types";

const idFromLocation = (location: string): string => {
  const trimmed = location.trim();
  if (!trimmed) {
    return "";
  }
  const withoutQuery = trimmed.split("?")[0];
  const segments = withoutQuery.split("/").filter(Boolean);
  return segments[segments.length - 1] ?? "";
};

export function parseComplianceVerifyJob(
  payload: unknown,
): ComplianceVerifyJob | null {
  if (payload == null || typeof payload !== "object") {
    return null;
  }
  const record = payload as Record<string, unknown>;
  const nested = objectField(record, "data") ?? record;
  const operationLocation = stringField(
    nested,
    "operationLocation",
    "operation_location",
  );
  const id =
    stringField(nested, "id") || idFromLocation(operationLocation);
  if (!id) {
    return null;
  }
  return {
    id,
    dispatched: numberField(nested, "dispatched"),
    operationLocation,
  };
}
